import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable max-len */
import React from 'react';
export function ExpandDownIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "44",
    height: "22",
    viewBox: "0 0 44 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22 22C34.1503 22 44 12.1503 44 0H0C0 12.1503 9.84974 22 22 22Z",
      fill: "#F2F2F2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 20C33.0457 20 42 11.0457 42 0H2C2 11.0457 10.9543 20 22 20Z",
      fill: "#134CD8"
    }), /*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M21.6114 12.9077L17.161 8.45728C16.9463 8.24264 16.9463 7.89466 17.161 7.68004L17.68 7.16097C17.8943 6.9467 18.2416 6.94629 18.4564 7.16006L22 10.6871L25.5436 7.16006C25.7584 6.94629 26.1057 6.9467 26.32 7.16097L26.839 7.68004C27.0537 7.89468 27.0537 8.24267 26.839 8.45728L22.3886 12.9077C22.174 13.1223 21.826 13.1223 21.6114 12.9077Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0",
        children: /*#__PURE__*/_jsx("rect", {
          x: "17",
          y: "5",
          width: "10",
          height: "10",
          fill: "white"
        })
      })
    })]
  });
}